import { render, staticRenderFns } from "./ScaleListPlugin.vue?vue&type=template&id=2a85a7c0&scoped=true"
import script from "./ScaleListPlugin.vue?vue&type=script&lang=ts"
export * from "./ScaleListPlugin.vue?vue&type=script&lang=ts"
import style0 from "./ScaleListPlugin.vue?vue&type=style&index=0&id=2a85a7c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85a7c0",
  null
  
)

export default component.exports